var lib_core = require("lib-core");
var lib_geometry = require("lib-geometry");

var GroupInfo = require("./groupInfo.js");

var DrawingElement = {

    /**
     *
     * @param parentGroup
     * @param {Array} [indices] If an array of groupindices is passed, only this groups of the parentGroup will be constructed
     */
    initGroups:function (parentGroup, indices, data) {
        var self = this;

        this.parentGroup = parentGroup;

        this.groupInfos = this.createGroupInfos(indices);

        this.groupInfos.forEach(function (index, groupInfo) {
            var parentGroupGroupInfo = parentGroup.getGroupInfo(groupInfo.layer);
            var id;
            if(data)
                id = data.$id;  // TODO: why is this necessary?!
            else if(self.data)
                id = self.data.$id;
            else
                id = "none";
            groupInfo.svgGroup = self.gui.svg.group(parentGroupGroupInfo.svgGroup, "id_" + id + "_" + groupInfo.layer);
        });

        this.selected = false;

        this.translation = new lib_geometry.Coord(0,0);

    },

    createGroupInfos:function (indices) {
        var groupInfos = new lib_core.Collections.HashMap();

        this.parentGroup.groupInfos.forEach(function (index) {
            if (indices == undefined || indices.indexOf(index) > -1){
                groupInfos.put(index, new GroupInfo(
                    index,
                    true,
                    index,
                    null,
                    true,
                    true
                ));
            }
        });

        return groupInfos;
    },

    getGroupInfo: function(layerIndex) {
        var result;
        result = this.groupInfos.get(layerIndex);
        return result;
    },

    removeSvg : function() {
        this.groupInfos.forEach(function(index,groupInfo){
            $(groupInfo.svgGroup).remove();
        });
    },

    emptySvgGroups : function() {
        this.groupInfos.forEach(function(index,groupInfo){
            $(groupInfo.svgGroup).empty();
        });
    },

//    copyPose : function(data) {
//        this.pos = data.pos();
//        this.angle = data.angle();
//        this.flip = data.flip();
//    },

    setTransform : function () {
        var self = this;


        this.groupInfos.forEach(function (index, groupInfo) {
            if (groupInfo.transform) {
                var transform = 'translate(' + (self.data.pos().x + self.translation.x)  + ',' + (self.data.pos().y + self.translation.y) + ')';

                if (groupInfo.rotate) {
                    transform += ' rotate(' + self.data.angle() + ') scale(' + self.data.flip() + ',1)';
                }

                self.gui.svg.change(groupInfo.svgGroup, {'transform':transform});
            }
        });

    },

    setTransform_ : function () {
        var self = this;
        var transform = this.data.getTransform();
        this.groupInfos.forEach(function (index, groupInfo) {
            $(groupInfo.svgGroup).children().attr('transform', transform);
        });
    },

    setTranslation : function (trans) {
        this.translation=trans;
        this.setTransform();
    },

    getTranslation : function() {
        return this.translation;
    },

    /**
     * @param {number} angle
     */
    setAngle : function (angle) {
        this.angle = angle;
        this.setTransform();
    },

    /**
     * @param {number} angle
     * @param center
     */
    rotate : function (angle, center) {
        if (!center) {
            this.angle += angle;
        } else {
            this.angle += angle;
            this.pos = this.pos.rotate(angle,center);
        }
        this.setTransform();
    },

    flipVer : function() {

        if (this.angle%180==0) {
            this.flip  = -1*this.flip;
        } else {
            this.angle = (this.angle + 180) % 360;
            this.flip  = -1*this.flip;
        }

        this.setTransform();
    },

    flipHor : function() {
        if (this.angle%180==0) {
            this.angle = (this.angle + 180) % 360;
            this.flip  = -1*this.flip;
        } else {
            this.flip  = -1*this.flip;
        }

        this.setTransform();
    },

    /**
     * @param {Coord} vec
     */
    move : function (vec) {
        this.pos = this.pos.add(vec);
        this.setTransform();
    },

    setSelected : function (selected) {
        var self = this;
        if(selected === this.selected) return;
        this.selected = selected;

        this.groupInfos.forEach(function (index, groupInfo) {
            if (self.selected === true) {
                self.gui.svg.change(groupInfo.svgGroup, {'opacity':0.5});
            } else {
                self.gui.svg.change(groupInfo.svgGroup, {'opacity':1});
            }
        });
    },

    internalbbox : function(group) {
        var bb = this.groupInfos.get(group).svgGroup.getBBox();
        var x1 = bb.x;
        var x2 = bb.x + bb.width;
        var y1 = bb.y;
        var y2 = bb.y + bb.height;
        return {x1 : x1, x2 : x2, y1 : y1, y2 : y2};
    },

    showInspector : function() {},

    hideInspector : function() {
        if(this.gui.inspector) {
            this.gui.inspector.hide();
        }
    }
};

module.exports = DrawingElement;
